export const blockIconsDeviceSell = (
	<span className='material-symbols-outlined'>sell</span>
);
